import styled from '@emotion/styled';
import { HeadingText as PPHeadingText } from '@paypalcorp/pp-react-text-weasley-v7';

export const HeadingText = styled(PPHeadingText)`
  margin: 0 0 12px;
`;
